const RouteURL = {
  //For maintain staging and production
  webMode: `local`,
  //webMode: `production`,
  version: "V 3.81",

  // For Attendance Routes

  attendanceByUser: "attendance",
  attendanceDashboardData: "/dashboard/attendance",
  monthlyAttendance: "attendance/register",

  // For Comp-Off Routes

  compOffList: "compoffs",
  applyCompOff: "compoff/add",
  compOffDetails: "compoff/",
  updateCompOffStatus: "compoff/",
  editCompOff: "/compoff/edit",

  // For Drive Routes

  accessDrive: "get-drive-token",
  createDirectory: "api/v1/createDirectory",
  rdDrive: "api/v1/getDriveList/",
  loadFolder: "api/v1/getDriveList/",
  getUploadUrl: "api/v1/get-upload-url",
  postUploadUrlShareMode: "api/v1/get-upload-url",
  getSubUploadUrl: "api/v1/get-upload-url",
  postSubUploadUrlShareMode: "api/v1/get-upload-url",
  uploadResBackend: "api/v1/updateUploadStatus",
  deleteFolder: "api/v1/deleteObject/",
  loadBreadcum: "api/v1/getBreadcum/",
  loadRootBreadcum: "api/v1/getBreadcum/",
  driveAnalyTicDetails: "api/v1/get-file-history/",

  //For Holiday Routes

  allHolidays: "holidays?",
  holidayDetails: "holidays/",

  //For TDS Routes
  UserTaxRequest: "/tds/get-user-request",
  getInvestmentCategory: "/tds/get-investment-category",
  addInvestmentDeclaration: "/tds/add-investment-declaration",
  changeDeclarationStatus: "/tds/declaration-status-update",
  taxDetails: "/tds/get-tax-details",
  taxIncomeDetails: "/tds/calculate-tax-amount",
  sendSchemeType: "/tds/update-investment-declaration-scheme",

  //For Job Routes

  allJobs: "jobs",
  allJobApplicants: "job-applicants-by-circular/",
  jobCircularStatusHistory: "/list-job-circular-status-history",
  jobApplicantsDetails: "candidates/",
  addJobApplicant: "candidates",
  applicantCVStatusChange: "update-cv-status",
  interviewStatusChange: "update-job-interview-status",
  interviewEmailSend: "send-interview-mail",
  jobDetails: "jobs",
  feedbackFields: "feedback-fields/",
  feedbackCategory: "feedback-category/",
  addFeedbackDetails: "add-interview-feedback/",
  editFeedbackDetails: "update-interview-feedback/",
  getFeedbackDetails: "get-interview-feedback/",
  jobSource: "job-source",
  addJob: "jobs",
  updateJob: "jobs/",
  updateJobApplicant: "update-candidates/",
  allCandidates: "candidates",
  allJobInterviews: "job-interviews",
  jobInterviewDetails: "job-interviews/",
  jobInterviewListByApplicant: "job-interviews/?job_applications_id=",
  jobInterviewListByUserType: "get-job-interview-list/",
  addJobInterview: "job-interviews/",
  updateJobInterview: "update-job-interviews/",
  addInterviewers: "add-interviwers",
  allInterviewers: "get-interviwers",
  deleteInterviewer: "delete-interviwers",
  allRecruiters: "get-recruiter",
  addRecruiters: "add-recruiter",
  deleteRecruiter: "delete-recruiter",
  allShortlistCv: "/job-applicants-by-circular/0",
  allInterviewMode: "get-job-interview-mode",
  allInterviewType: "get-job-interview-type",
  getMachinetestResult: "job/get-machinetest-result",
  addCity: "job/add-city",
  addSource: "/job/add-source",
  salaryConfigurationDetailsByLocation:
    "candidate-salaryconfigurations-by-location",
  createSalaryConfiguration: "candidate-salaryconfigurations",
  updateSalaryConfiguration: "candidate-salaryconfiguration-update",
  deleteSalaryConfiguration: "candidate-salaryconfigurations/",
  salaryConfigurations: "salaryconfiguration-by-candidate/",
  salaryCalculations: "candidate-calculate-salary",
  templateList: "list-offer-template/",
  getOfferDetails: "get-offer-template",
  submitOfferDetails: "save-offer-letter",
  getOfferList: "get-user-documents-list",
  deleteOffer: "delete-offer-letter",
  LanguageList: "api/v1/user/get-language-list",
  LanguagesList: "/get-language-list",
  deleteJob: "/jobs/delete",
  deleteCandidate: "/candidate/delete",
  deleteInterview: "/interview/delete",
  getAllDepartment: "/get-all-department",
  jobGetAllInterviewDetails: "job/get-all-interview-details",
  getReasonForChangeHistory: "/job-status-history",
  jobApplicantsByStatus: "/list-candidate-by-status",
  addEditListFields: "/dynamic-field/add-edit-list-fields",
  getFieldList: "/dynamic-field/get-list-fields",
  mailSentForOnboarding: "/onboarding-request",
  verifyOnBoardDataByAdmin: "/check-submit-data-by-admin",
  //For Leave Routes

  leaveCategory: "leaveCategory/",
  leaves: "leaves",
  leaveDetails: "leaves/",
  leaveHistory: "leave-history",
  leaveSummary: "leave-summary",
  applyLeave: "leave/add",
  teamLeaves: "team-leaves",
  updateLeaveStatus: "leaves/",
  editLeave: "/leave/edit",
  leaveCategoryWithCompOff: "leave-category-with-compoff",
  employeeCalenderLeaves: "/calender/list-leaves-all",
  downloadLeaveFile: "/get-static-file-link",
  getLeaveBalanceData: "/get-leave-balances",

  // assigned asset
  getAssignedAsset: "asset/get-asset-assigned-users",
  getAssignedAssetUserWise: "asset/get-assigned-assets",

  //For Salary Routes

  generateSalaryDetails: "get-details-by-salary-id",
  allPublishPayslip: "/all-published-salary-employee",
  downloadPayslipByID: "download-payslip-by-id",
  salaryConfiguration: "salaryconfiguration-by-user/",
  salaryConfigurationsDetailsByLocation: "salaryconfigurations-by-location",

  //For Service Routes

  login: "login",
  generateOTP: "generate-otp",
  verifyOTP: "verify-otp",
  resendOTP: "resend-otp",
  changePassword: "change-password",
  users: "users",
  departments: "get-all-department/",
  designations: "designations/",
  getOrganizationChart: "get-organization-chart/",
  userDetails: "users/",
  locations: "get-all-location/",
  company: "list-company/",
  employee_status: "get-all-employment-status/",
  employee_type: "get-all-employment-type/",
  getDocumentList: "get-user-documents-list",
  cityList: "get-all-cities",
  allUsers: "get-all-users",
  clockIn: "clock-in",
  clockOut: "clock-out",
  clockInOutStatus: "get-clock-in-out-status",
  teamMembersList: "team-members",
  forgotPasswordClick: "generate-otp-forget-password",
  verifyForgotPasswordOTP: "verify-otp-forget-password",
  resetForgotPassword: "reset-password",
  getAllDocumentsList: "get-user-documents-list",
  kraCategoryList: "/kra/get-category-master",
  getKRADetails: "/kra/kra-details",
  getAllDocumentsType: "/get-document-type",

  getCVDetails: "/cv/get",
  saveCVDetails: "/cv/add-edit",
  cvDownload: "/cv/download",
  cvDownloadHTML: "/cv/download-html",
  AreaOfSkillList: "/cv/get-cv-skill-master",
  AddAreaOfSkill: "cv/add-cv-skill-master",
  AreaOfExpertiseList: "/cv/get-cv-expertise-master",
  getTrackerBuildDetails: "/tracker/get-trackers",

  //For Tracker Routes

  userTrackerDetails: "tracker-user-details",
  allTrackerViewPermission: "get-tracker-view-users",

  //For Working Hour Routes

  getUserWorkingHours: "get-user-working-hours/",
  addWorkingHoursException: "add-user-time-change-request",
  editWorkingHoursException: "edit-user-time-change-request",
  workingHoursExceptionDetails: "user-time-change-request-details",
  workingHoursExceptionList: "list-user-time-change-request",
  getWorkingDayDetails: "/dashboard/attendance-datewise",
  deleteException: "delete-user-time-change-request",

  //For Sales Routes
  getLeadSource: "sales/get-lead-source",
  addLead: "/sales/add-lead",
  editLead: "/sales/edit-lead",
  getListLeads: "/sales/list-leads",
  addMoreQuery: "/sales/add-query",
  getListQuery: "/sales/list-query",
  getIdByLeadDetails: "/sales/lead-details",
  getIdByQueryDetails: "/sales/query-details",
  addProposal: "sales/add-proposal",
  getListProposal: "sales/list-proposal",
  getIdBytProposalDetails: "/sales/proposal-details",


  //sales Contacts
  //getLifecyclestagelist: "sales/get-lifecyclestagelist/0",
  getLifecyclestagelist: "sales/get-lifecyclestagelist/",
  getLeadstatuslist: "sales/get-leadstatuslist/0",
  getSalescontact: "sales/get-salescontact",
  addSalescontact: "sales/add-salescontact",
  getSalesuserlist: "sales/get-salesuserlist",
  addSalesuser: "sales/add-salesuser",
  deleteSalesuser: "sales/delete-salesuser",
  getCountrieslist: "sales/get-countrieslist",
  editSalescontact: "sales/edit-salescontact",
  deleteSalescontact: "sales/delete-salescontact",
  getSalesContactDetails: "sales/get-salescontactdetails",
  addSalesNotes: "sales/add-salesnotes",
  getSalesNotesList: "sales/get-salesnoteslist",
  editSalesNotes: "sales/edit-salesnotes",
  deleteSalesNotes: "sales/delete-salesnotes",
  addSalesTask: "sales/add-salestask",
  getSalesContactMasterData: "sales/get-salescontactmasterdata",
  getSalesTaskList: "sales/get-salestasklist",
  editSalesTask: "sales/edit-salestask",
  deleteSalesTask: "sales/delete-salestask",
  addSalesComment: "sales/add-salescomment",
  editSalesComment: "sales/edit-salescomment",
  deleteSalesComment: "sales/delete-salescomment",
  addSalesTaskComment: "sales/add-salestaskcomment",
  editSalesTaskComment: "sales/edit-salestaskcomment",
  deleteSalesTaskComment: "sales/delete-salestaskcomment",
  isEmailConfigured: "is-email-configured",
  addUsersEmail: "sales/add-usersemail",
  verifyEmailOtp: "sales/verify-email-otp",
  sendSalesEmail: "sales/send-sales-email",
  getSalesEmailList: "sales/get-sales-email-list",
  addSalesEmailLog: "sales/add-sales-email-log",
  editSalesEmailLog: "sales/edit-sales-email-log",
  deleteSalesEmailLog: "sales/delete-sales-email-log",
  replySalesEmail: "sales/reply-sales-email",
  getSalesEmailReplyList: "sales/get-sales-email-reply-list",
  getContactActivity: "sales/get-contact-activity",
  updateSalestaskStatus: "sales/update-salestask-status",
  deleteUsersEmail: "sales/delete-usersemail",
  addMeetingLog: "sales/add-meeting-log",
  getMeetingList: "sales/get-meeting-list",
  dashboardStatistics: "sales/dashboard-statistics",
  dashboardActivityList: "sales/dashboard-activity-list",


  dealsAdd: "sales/deals-add",
  dealsEdit: "sales/deals-edit",
  dealsList: "sales/deals-list",
  dealsDelete: "sales/deals-delete",
  getContactSourceList: "sales/get-contact-source-list/0",
  getContactMediumList: "sales/get-contact-medium-list/0",
  getDealStageList: "sales/get-deal-stage-list/0",
  getDealProposalStatus: "sales/get-deal-proposal-status/0",
  getDealProposalRemarks: "sales/get-deal-proposal-remarks/0",
  addDealProposalRemarks: "sales/add-deal-proposal-remarks",
  addContactMedium: "sales/add-contact-medium",
  addDealProposalStatus: "sales/add-deal-proposal-status",
  editDealProposalStatus: "sales/edit-deal-proposal-status",
  editContactSource: "sales/edit-contact-source",
  editContactMedium: "sales/edit-contact-medium",
  editDealStage: "sales/edit-deal-stage",
  editDealProposalRemarks: "/sales/edit-deal-proposal-remarks",
  deleteContactMedium: "sales/delete-contact-medium",
  deleteContactSource: "sales/delete-contact-source",
  deleteDealStage: "sales/delete-deal-stage",
  deleteDealProposalStatus: "sales/delete-deal-proposal-status",
  deleteDealProposalRemarks: "sales/delete-deal-proposal-remarks",
  addDealStage: "sales/add-deal-stage",
  dealsEdit: "sales/deals-edit",
  dealsAddProposal: "sales/deals/add-proposal",
  dealsEditProposal: "sales/deals/edit-proposal",
  dealsGetProposal: "sales/deals/get-proposal",
  dealsAddMilestone: "sales/deals/add-milestone",
  dealsEditMilestone: "sales/deals/edit-milestone",
  dealsGetMilestone: "sales/deals/get-milestone",
  dealsAddMilestonePayment: "sales/deals/add-milestone-payment",
  dealsEditMilestonePayment: "sales/deals/edit-milestone-payment",
  dealsDeleteMilestonePayment: "sales/deals/delete-milestone-payment",
  dealsDeleteMilestone: "sales/deals/delete-milestone",
  dealsDeleteProposal: "sales/deals/delete-proposal",
  getDashboardData: "sales/deals/get-dashboard-data",
  raiseMilestoneInvoice: "sales/deals/raise-milestone-invoice",
  salesDealsGetDashboardStatistics: "sales/deals/get-dashboard-statistics",

  getSalesDailyReport: "sales/report/get-daily-report",
  createDailySalesReport: "sales/report/add-daily-report",
  editDailySalesReport: "sales/report/edit-daily-report",

  // for sales sequence
  addSalesSequence: "/sequence/add-sales-sequence",
  getSalesSequenceList: "/sequence/get-sales-sequence-list",
  getSalesContactList: "/sequence/get-sales-contact-list",
  addSequenceContactFromList: "/sequence/add-sequence-contact",
  uploadCsvFile: "/sequence/upload-csv",
  getSequenceContactList: "/sequence/get-sequence-contact-list-id",

  addSequenceStep: "/sequence/add-sequence-step",
  getSequenceStepList: "/sequence/get-sequence-step-list",
  deleteSequenceStep: "/sequence/delete-sequence-step",
  editSequenceStepStatus: "/sequence/change-sequence-status",
  sendContactFields: "/sequence/send-contact-fields",
  updateSequenceStatus: "/sequence/update-sequence-and-step-status",
  updateSequenceScheduleDateTime: "/sequence/update-schedule-date-time",
  getStepContactList: "/sequence/get-step-contact-list-by-id",
  changeIsInterestStatus: "/sequence/change-is-interest-status",
  emailTemplateList: "/sequence/get-sales-sequence-template-list",
  sequenceConditionList: "sequence/get-sequence-condition-list",
  editStepTemplate: "/sequence/edit-step-template",
  deleteSequence: "/sequence/delete-sequence",
  sendStepEmail: "/sequence/send-step-email",
  ////
  //For Tickets
  addTicketManagers: "ticket/add-ticket-managers",
  getTicketManagers: "ticket/get-ticket-managers",
  addTicket: "ticket/add-ticket",
  getTickets: "ticket/get-tickets",
  editTicket: "ticket/edit-ticket",
  deleteTicket: "ticket/delete-ticket",
  addTicketComment: "ticket/add-ticket-comment",
  getTicketCategory: "ticket/get-ticket-category",
  listAccessByEmployee: "ticket/list-access-by-employee",
  listAccess: "ticket/list-access",
  listUsersWithAccessControl: "ticket/list-users-with-access-control",
  addAccessDetails: "ticket/assign-user-access",

  ////
  //For Inventory Routes

  getAllAssetType: "/asset/get-asset-type",
  loadAssetCategoryList: "/asset/list-asset-category/",
  loadAttriButeList: "/asset/get-attributes-by-category",
  getAllAssetStatus: "/asset/get-asset-status",
  addAsset: "/asset/add-asset",
  loadAssetList: "/asset/list-assets",
  getAssetDetails: "/asset/get-asset-details",
  editAsset: "/asset/edit-asset",
  deleteAsset: "/asset/delete-asset",
  assignAsset: "/asset/asset-allocation",
  getAssetIdCompanyWise: "asset/get-asset-id",

  getAssignedAssetsEmployee: "asset/get-assigned-assets-employee",
  // For company wise user list

  allUsersCompanyWise: "/get-all-users_by_company",

  // For Visitor Management 
  visitorManagerlogin: "/visitor/login",
  addVisitors: "/visitor/add-visitor-by-manager",
  allVisitors: "/visitor/get-visitorlist",
  visitorTimeOut: "/visitor/visitor-time-out",
  generateVisitorOTP: "/visitor/generate-otp",
  verifyVisitorOTP: "/visitor/verify-otp",
  visitorManagerLoginLocations: "/visitor/get-visitor-location-master-list",


  //For training
  allTrainingList: '/training/get-training-list-participant',
  getTrainingDetails: "/training/get-training-details",
  trainingMaterialList: "/training/get-material-list",
  reminderList: '/training/get-reminder-list',
  addTraining: '/training/add-training',
  updateTraining: "/training/edit-training",
  deleteTraining: "/training/delete-training",
  getTrainingIdCompanyWise: "/training/get-training-id",
  getTrainingStatusChange: "/training/change-training-status",
  deleteAttendanceFile: "/training/delete-attendance",
  addAttendanceFile: "/training/add-attendance",
  addTrainingParticipant: "/training/add-participants",
  deleteTrainingParticipant: "/training/delete-participant",
  trainingParticipantList: "/training/get-participant-list",
  addTrainingMaterial: "/training/add-material",
  deleteTrainingMaterial: "/training/delete-material",
  changeParticipantStatus: '/training/change-participant-status',
  venueList: "/training/list-venue",
  getTrainingUserParticipant: "/training/list-training-user",



  getJobTitleList: '/get-job-titles',
  //For appraisal
  createAppraisalEvent: "appraisal/create-appraisal-event",
  getAllAppraisalEvent: "appraisal/get-all-appraisal-event",
  deleteAppraisalEvent: "appraisal/delete-appraisal-event",
  editAppraisalEvent: "appraisal/edit-appraisal-event",
  addParticipantsForAppraisalEvent: "appraisal/add-participants-for-appraisal-event",
  getAllParticipantsForAppraisalEvent: "appraisal/get-all-participants-for-appraisal-event",
  deleteParticipantsFromAppraisalEvent: "appraisal/delete-participants-from-appraisal-event",
  getAllReviewerForAppraisalEvent: "appraisal/get-all-reviewer-for-appraisal-event",
  addReviewerForAppraisalEvent: "appraisal/add-reviewer-for-appraisal-event",
  deleteReviewerForAppraisalEvent: "appraisal/delete-reviewer-for-appraisal-event",
  getParticipantDetailsForAppraisalEvent: "appraisal/get-participant-details-for-appraisal-event",
  changeMainReviewerStatus: "appraisal/change-main-reviewer-status",
  submitRatingForAppraisalEvent: "appraisal/submit-rating-for-appraisal-event",
  isAppraisalReviewer: "appraisal/is-appraisal-reviewer",
  sendConsolidatedReport: "appraisal/send-consolidated-report",
  viewConsolidatedReport: "appraisal/view-consolidated-report",


  //For data mining
  getDataMiningLeadList: '/data-mining/list-contact',
  addDataMiningLead: "/data-mining/add-contact",
  updateDataMiningLead: "/data-mining/edit-contact",
  deleteDataMiningLead: '/data-mining/delete-contact',
  dataMiningLeadDetails: '/data-mining/contact-details',
  uploadDataMiningLeadCsvFile: "/data-mining/upload-csv",

  addLeadContactFromList: "data-mining/create-contact-from-import",
  statusChangeDataMiningLead: "data-mining/update-contact-status",
  getDataMiningGeneratedBy: "data-mining/generated-by",
  getDataMiningIndustry: "data-mining/industry",
  getDataMiningPurpose: "data-mining/purpose",

  //for reimbursement
  getReimbursementList: '/reimbursement/list-reimbursement',
  addReimbursement: "/reimbursement/apply-reimbursement",
  updateReimbursement: "/reimbursement/edit-reimbursement",
  deleteReimbursement: '/reimbursement/delete-reimbursement',
  ReimbursementDetails: '/reimbursement/reimbursement-details',

  // For Announcements
  allAnnouncements: "/announcement/list-announcements",
  feedbackFormFieldDetail: "/announcement/form-details",
  submitAnnouncementFeedback: "/announcement/add-feedback-details",
  getUnreadMessageCount: "/announcement/get-unread-count",
  updateReadStatus: "/announcement/update-read-status",


  // for dashboard
  getPlannedUnplannedLeave: "/dashboard/planned-unplnned-leave",
  trackerActivityLog: "get-tracker-activity",


  // for Projects
  getProjectList: "/projects/list-project",
  addProject: "/projects/add-project",
  updateProject: "/projects/update-project",
  deleteProject: "/projects/delete-project",
  addProjectClients: "/projects/add-client",
  getClientsList: "/projects/get-clients",
  getProjectBillingType: "/projects/get-project-billing-type",
  getProjectCategory: "/projects/get-project-category",
  checkPrefix: "/projects/check-prefix",
  projectStatus: "/projects/get-project-status",
  projectUserRole: "/projects/get-project-user-role",
  projectUserList: "/projects/get-user-list",//all user list with departments
  projectAddTeamMember: "/projects/add-team-member",
  projectDocumentType: "/projects/get-project-document-type",
  projectAddDocument: "/projects/add-project-document",
  projectGetDocument: "/projects/get-project-document",
  projectInitiationEmail: "/projects/sent-initiation-email",
  deleteProjectDocument: "/projects/delete-project-document",
  projectAddEfforts: "/projects/add-effort",
  projectsEditProjectDocument: "projects/edit-project-document",

  projectSprintList: "/projects/list-sprint",
  addProjectSprint: "/projects/add-sprint",
  editProjectSprint: "/projects/update-sprint",
  getProjectSprint: "/projects/get-sprint-details",
  deleteProjectSprint: "/projects/delete-sprint",
  projectEpicList: "/projects/list-epic",
  addProjectEpic: "/projects/add-epic",
  editProjectEpic: "/projects/update-epic",
  getProjectEpic: "/projects/get-epic-details",
  deleteProjectEpic: "/projects/delete-epic",
  projectSprintStatusList: "/projects/list-sprint-status",
  projectSprintUserList: "/projects/list-project-user",//all user under projects

  projectBacklogList: "/projects/list-project-task",
  addProjectBacklog: "/projects/add-project-task",
  editProjectBacklog: "/projects/update-project-task",
  getProjectBacklog: "/projects/get-task-details",
  deleteProjectBacklog: "/projects/delete-project-task",

  priorityList: "/projects/get-priority",
  getAllSprintList: "/projects/list-sprint-all",
  getTaskStatus: "/projects/get-task-status",// "status_type": "task_user_story" / "issue" /"client"
  getUserStoryList: "/projects/user-story-list-all",

  addProjectTaskOwner: "/projects/add-project-task-owner",
  editProjectTaskOwner: "/projects/edit-project-task-owner",
  deleteProjectTaskOwner: "/projects/delete-project-task-owner",
  editProjectIssueOwner: "/projects/edit-project-issue-owner",

  getIssueCategory: "/projects/get-issue-category",
  addIssueCategory: "/projects/add-issue-category",
  addProjectIssue: "/projects/add-project-issue",
  getProjectIssueList: "/projects/get-project-issue-list",
  addProjectIssueOwner: "/projects/add-project-issue-owner",
  updateProjectIssue: "/projects/update-project-issue",
  deleteProjectIssueOwner: "/projects/delete-project-issue-owner",
  deleteProjectIssue: "/projects/delete-project-issue",
  changeIssueOwnerStatus: "/projects/changes-issue-owner-status",
  changeTaskOwnerStatus: "/projects/changes-task-owner-status",
  deleteTaskAttachment: "/projects/delete-task-attachment",
  deleteIssueAttachment: "/projects/delete-issue-attachment",
  addProjectTimeSheet: "/projects/add-timesheet",
  getTimeSheetList: "/projects/list-timesheet",
  deleteProjectTimesheet: "/projects/delete-timesheet",
  editProjectTimeSheet: "/projects/update-timesheet",
  getProjectStatusReport: "/projects/employee-status-report",

  getDashBoardStatistics: "/projects/project-dashboard-statistics",
  updateProjectStatus: "/projects/update-project-status",
  updateTaskStatus: "/projects/update-project-task-status",
  updateIssueStatus: "/projects/update-project-issue-status",
  projectPermissionCheck: "/projects/permissions-check",
  projectDashboardTaskStatus: "/projects/project-dashboard-task-status",
  projectDashboardEmpHours: "/projects/project-dashboard-employee-hours",
  projectDashboardDeptHours: "/projects/project-dashboard-department-hours",
  projectsGetTeamMember: "projects/get-team-member",
  projectsEditProject: "projects/edit-project",
  projectsDeleteTeamMember: "projects/delete-team-member",
  projectsGetProjectNotes: "projects/get-project-notes",
  projectsAddProjectNotes: "projects/add-project-notes",
  projectsEditProjectNotes: "projects/edit-project-notes",
  projectsDeleteProjectNotes: "projects/delete-project-notes",
  getMyTimeSheetList: "projects/list-timesheet-all",
  projectsListAdditionalEffort: "projects/list-additional-effort",
  projectsAddadditionalEffort: "projects/add-additional-effort",
  projectsUpdateAdditionalEffort: "projects/update-additional-effort",
  projectsDeleteAdditionalEffort: "projects/delete-additional-effort",
  getProjectTimelineReport: "projects/project-timeline-report",
  getSprintMinMaxDate: "projects/get-sprint-minmax-date",
  projectCustomDepartmentList:"/projects/get-effort-list",


  // for Change Request
  getAllProjectList: "projects/list-project-all",
  addChangeRequest: "projects/add-change-request",
  editChangeRequest: "projects/edit-change-request",
  deleteChangeRequest: "projects/delete-change-request",
  getChangeRequest: "projects/get-change-request",

  // for meeting page
  addMeeting: "add-meeting",
  listMeeting: "list-meetings",
  updateMeeting: "update-meeting",
  deleteMeeting: "delete-meeting",



  userManualList: "/user-manual-list",

  // academy_lead
  listAcademyLead: "academy/list-academy-lead",
  listAcademyLeadSource: "academy/list-academy-lead-source",
  listAcademyLeadCourse: "academy/academy-course-list",
  addAcademyLead: "academy/add-academy-lead",
  updateAcademyLead: "academy/update-academy-lead",
  deleteAcademyLead: "academy/delete-academy-lead",
  listAcademyLeadFollowUp: "academy/list-academy-lead-follow-up",
  listAcademyLeadFollowUpStatus: "academy/list-academy-lead-follow-up-status",
  addAcademyLeadFollowUp: "academy/add-academy-lead-follow-up",
  updateAcademyLeadFollowUp: "academy/update-academy-lead-follow-up",
  deleteAcademyLeadFollowUp: "academy/delete-academy-lead-follow-up",
  uploadAcademyLeadCsvFile: "academy/upload-csv",
  addAcademyLeadFromList: "academy/add-lead-from-import",



  // academy_source
  getAllSource: '/academy/list-academy-lead-source',
  addLeadSource: '/academy/add-lead-source',
  updateSource: 'academy/update-lead-source',
  deleteSource: '/academy/delete-lead-source',



  // academy_course
  getAllCourse: '/academy/academy-course-list',
  addCourse: '/academy/add-academy-course',
  updateCourse: '/academy/update-academy-course',
  deleteCourse: '/academy/delete-academy-course',

  //academy_status

  getAllStatus: '/academy/list-academy-lead-follow-up-status',
  addStatus: '/academy/add-lead-follow-up-status',
  updateStatus: '/academy/update-lead-follow-up-status',
  deleteStatus: '/academy/delete-lead-follow-up-status',

  // for release page
  addRelease: "release/add-release",
  editRelease: "release/edit-release",
  listRelease: "release/get-release",
  deleteRelease: "release/delete-release",
  projectSprintTaskList: "/projects/task-userstory-list-all",//all task under projects sprint

  // for effort page
  updateEffort: "projects/update-effort",
  getDistributedEffort: "projects/get-effort",
  updateDistributedEffort: "projects/add-effort",
  isProjectMemberExist:"projects/is-project-member-exist",

  // for task and issue settings
  getStatusList: "/projects/get-task-status",// "status_type": "task_user_story" / "issue"
  addProjectStatus: "/projects/add-task-status",
  editProjectStatus: "/projects/edit-task-status",
  deleteProjectStatus: "/projects/delete-task-status",

  //  team member
  updateTeamMember: "/projects/update-team-member",

  //project comment
  addProjectComment: '/projects/add-project-comment',
  editProjectComment: '/projects/edit-project-comment',
  getProjectComment: '/projects/get-project-comment',
  deleteProjectComment: '/projects/delete-project-comment',

  //chat list
  chatUserList: "/chat/get-chat-user-list",
  getAllMessage: "/chat/get-all-messages",
  getChatFileUrl: "/chat/get-upload-url",
  getGroupChatFileUrl: "/chat/get-group_image-upload-url",
  createMessageBox: "/chat/create-project-message-board",

  timeSheetActivityDaily: "/projects/timesheet-activity-daily",
  timeSheetActivityMonthly: "/projects/timesheet-activity-monthly",
  timesheetStatistics: "/projects/timesheet-statistics",

  globalTaskList: "/projects/list-task-global",
  timeSheetByType: "/projects/timesheet-by-type",
  listTimeSheetTeam: "/projects/list-timesheet-team",
  updateTimeSheetStatus: "/projects/update-timesheet-status",


  submitTimesheetForApproval: "projects/submit-timesheet-for-approval",
  getMyProjectList: "projects/get-my-project-list",
  getTimesheetApprovalRequests: "/projects/get-timesheet-approval-requests",
  getTimesheetStatusByRequests: "/projects/get-timesheet_stats-by-request",
  updateTimesheetApprovalStatus: "/projects/update-timesheet_approval-status",

  addProjectFolderDocument: "/projects/add-document",
  editProjectFolderDocument: "/projects/edit-document",
  getProjectFolderDocument: "/projects/get-document",
  deleteProjectFolderDocument: "/projects/delete-document",

  websiteCandidateList: '/job/list-website-candidate',
  updateWebsiteCandidate: '/job/update-website-candidate',
  uniqueCandidateHistory: '/job/candidate-history',
  uniqueCandidateList: '/job/list-unique-candidates',
  teamTaskList: '/projects/list-team-tasks',
  getSalesContactHistory: "/sales/get-salescontact-history",
  getAppointments: "/sales/get-appointments",
  updateAppointment: "/sales/update-appointment",
  countryWiseContactCount: "/sales/countrywise-contact-count",
  pageWiseContactCount: "/sales/pagewise-contact-count",
  getChatHistory: "/sales/get-salescontact-chat-history",

  deleteUserFromMsgBoard: "/chat/remove-group-member",
  getChatForms: "/sales/get-chat-forms",
  getChatFormsData: "/sales/get-chat-forms-data",
  getChatAttachments: "/sales/get-chat-attachments",
  getChatRequest: "/sales/get-chat-requests",
  getChatbotAllMessage: "/sales/get-chat-messages",
  getSalesChatbotFileUrl: "/sales/get-chatbot-file-upload-url",
  listPageDetails: "/sales/list-page-details",

  codeReviewGetFeedback: "code-review/get-feedback",
  codeReviewAddFeedback: "code-review/add-feedback",
  codeReviewGetReviewRequest: "code-review/get-review-request",
  codeReviewGetTemplateDetails: "code-review/get-template-details",
  codeReviewUpdateFeedback: "code-review/update-feedback",
  getAllFeedback: "code-review/get-all-feedback",


  // red apple website
  calenderManageGetSalesUser: "calender-manage/get-sales-user",
  SalesAddContactWeb: "sales/add-contact-web",

  getWebsiteVisitUrls: "/sales/get-visit-urls",
  getCostFieldCategory: "/cost-manage/get-field-category",
  getCategoryFields: "/cost-manage/get-field-public",
  costContactFormSubmit: "/cost-manage/generate-estimate",

  getHireTeamList: "/team-manage/get-team",
  getHireTeamOfferList: "/team-manage/get-offer-by-availability",
  hireTeamContactFormSubmit: "/team-manage/generate-team-hire-estimation",
  getUpdationMasterData: "/cost-manage/get-updation-master-data",
  generateUpdationCost: "/cost-manage/generate-updation-cost",

  // project api tab

  addProjectApiCollection: "/api/create-collection",
  getAllCollectionList: "/api/list-collection",
  addProjectApiEnvironment: "/api/add-api-environment",
  getAllEnvironmentList: "/api/list-api-environment",
  addAndUpdateApi: "/api/add-update-api",
  getProjectApiDetails: "/api/get-api-details",
  deleteApi: "/api/delete-api",
  importCollection: "api/import-collection",
  requestAPI: "api/request-api",
  deleteCollection: "api/delete-collection",
  updateApiEnvironment: "api/update-api-environment",


  allSubmittedTimesheet: "/projects/list-employee-timesheet-status",

  leavesListForManager: "/leave/leaves-for-manager",
  updateLeaveByManager: "/leave/approve-by-manager",


  // client interview
  clientInterviewScheduleInterview: "/client-interview/schedule-interview",
  clientInterviewGetInterviews: "client-interview/get-interviews",
  clientInterviewSubmitFeedback: "client-interview/submit-feedback/",
  clientSubmitInterviewStatus: "client-interview/submit-interview-status/",
  clientInterviewGetCandidateList: "client-interview/get-candidate-list",

  //  cost calculetion
  getCostFieldCategory: "/cost-manage/get-field-category",
  addCostField: "/cost-manage/add-field",
  getCostField: "/cost-manage/get-field",
  updateCostField: "/cost-manage/update-field",
  teamManageGetOffer: "/team-manage/get-offer",
  teamManageAddOffer: "/team-manage/add-offer",
  teamManageUpdateOffer: "/team-manage/update-offer",
  teamManageDeleteOffer: "/team-manage/delete-offer",
  teamManageAddTeamCategory: "/team-manage/add-team-category",
  teamManageUpdateTeamCategory: "/team-manage/update-team-category",
  teamManageGetTeam: "/team-manage/get-team-for-admin",
  teamManageDeleteCategoryAndTeams: "/team-manage/delete-category-and-teams",

  //  video portfolio
  videoPortfolioConatactEmailOTP: "/sales/generate-contact-email-otp",
  videoPortfolioAddContact: "/sales/add-contact-web",
  videoPortfolioList: "/sales/video-portfolio-list",
  videoPortfolioLikeDislikeUpdate: "/sales/video-portfolio-stats",

  getPipDetails: "/pip-manage/get-pip",
  pipFeedbackList: "/pip-manage/list-feedback",

  UpdateTicketStatus: "/ticket/update-ticket-status",
  UpdateTicketAssignTo: "/ticket/update-assigned-to",


  //For confirmation
  getAllConfirmationEvent: "confirmation/get-all-confirmation-event",
  getAllParticipantsForConfirmationEvent: "confirmation/get-all-participants-for-confirmation-event",
  getParticipantDetailsForConfirmationEvent: "confirmation/get-participant-details-for-confirmation-event",
  submitRatingForConfirmationEvent: "confirmation/submit-rating-for-confirmation-event",
  isConfirmationReviewer: "confirmation/is-confirmation-reviewer",
  sendConsolidatedConfirmationReport: "confirmation/send-consolidated-report",
  viewConsolidatedConfirmationReport: "confirmation/view-consolidated-report",

  //Sales Documents
  addSalesFolderDocument: "/sales/add-folder",
  editSalesFolderDocument: "/sales/edit-folder",
  getSalesFolderDocument: "/sales/get-folder",
  deleteSalesFolderDocument: "/sales/delete-folder",

  //on boarding
  getOnBoardingCandidateDetails: "/get-onboarding-candidade-details",
  verifyOnBoardingCandidate: "/onboarding-candidate-verification",
  getOnBoardingCandidateOTPVerificationDetails: "/get-onboarding-candidate-verification-details",
  updateOnBoardingCandidateDetails: "/update-onboarding-candidate-details",
  addOnBoardingUserEducation: "/add-onboarding-candidate-education",
  onBoardingCandidateEducationList: "/get-education-details",
  deleteOnBoardingUserEducation: "/delete-onboarding-education-details",
  onboardingFinalSubmission: "onboarding-final-submition",
  getOnBoardingCandidateVerificationDetails: "/get-onboarding-candidate-verification-details-by-admin",
  onBoardingUserEducationList: "/get-education-details-by-admin",

  //Meeting Room Booking
  getMeetingRoomBookingHost: "meeting-room-booking-host-list",

  meetingRoomBookingVenueList: 'meeting/get-venue-list',
  allMeetingRoomBookingList: 'meeting/meeting-room-booking-list',
  addMeetingRoomBooking: 'meeting/add-meeting-room-booking',
  editMeetingRoomBooking: 'meeting/edit-meeting-room-booking',
  getMeetingRoomBookingDetails: 'meeting/get-meeting-details',
  deleteMeetingRoomBooking: 'meeting/delete-meeting-room-booking',
  getMeetingIdCompanyWise: 'meeting/company-wise-meeting-id',
  meetingRoomBookingStatusChange: 'meeting/meeting-room-booking-status-change',


};

export default RouteURL;